import React from 'react';
import MriSimmonsLogo from '../components/common/MriSimmonsLogo';
import { ERROR_MESSAGES, SIGNOUT_MESSAGE } from '../constants';
import WarningIcon from '../components/common/Icons/WarningIcon';
import { logOut } from '../actions/loginActions';

const ConcurrentUserErrorMessage = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const code = atob(urlParams.get('code'));
  const errorMsg = ERROR_MESSAGES.find(e => e.key === code).value;

  return (
    <div className="unlock-screen">
      <div className="unlock-card-box">
        <div className="unlock-card">
          <div className="unlock-card-header">
            <div className="mri-simmons-logo">
              <MriSimmonsLogo height={66} width={336} />
            </div>
          </div>
          <div className="unlock-card-body">
            <WarningIcon />
            <div className="unlock-error-message">{errorMsg}</div>
            <button type="button" onClick={() => logOut()}>
              &lt; {SIGNOUT_MESSAGE}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConcurrentUserErrorMessage;
